import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from 'react-spinners';
import Skeleton from 'react-loading-skeleton'
import { Table } from "antd";
import { adminMainUrl } from '../../Config.jsx';
import { getContractInfo, getCustomerContracts, getCustomerProfileData, getCustomerUpdateProfileData } from "../../Redux/action/Admin/CustomerAction.js";
import Pagination from "../../Admin/Masters/Pagination.jsx";
import axios from "axios";
import { DDMMMYYYYformateDate, isExpiringInTwoDays } from "../../HelperFunctions.js";
import EditContract from "./EditContract.jsx";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


const CustomerContractManagementList = () => {

  const { b64id } = useParams();
  const navigate = useNavigate()
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const token = Cookies.get("customertoken");
  const [showRenewalButton, setShowRenewalButton] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [dataOffset, setDataOffset] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const dataPerPage = 10;
  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [disable, setDisable] = useState(false);


  const [showEditContract, setShowEditContract] = useState(false);
  const [contract_id, setContract_id] = useState("");
  const handleCloseEditContract = () => setShowEditContract(false);
  const handleShowEditContract = () => setShowEditContract(true);
  const dispatch = useDispatch();


  useEffect(() => {
    if (contract_id) {
      dispatch(getContractInfo(contract_id));
    }
  }, [contract_id]);



  // const { name } = useParams();
  const {
    loadingCustomerContracts,
    CustomerContractsError,
    CustomerContracts,

    loadingContractInfo,
    ContractInfo,
    ContractInfoError,

    loadingCustomerUpdateProfileDataApi, CustomerUpdateProfileDataError, CustomerUpdateProfileData,

  } = useSelector((state) => state?.CustomerReducer);


  useEffect(() => {
    if (CustomerContracts) {
      if (Array.isArray(CustomerContracts) && CustomerContracts.length) {
        let lastContract = CustomerContracts[CustomerContracts.length - 1];
        if (lastContract) {
          if (lastContract.contract_expiry_date) {
            let contractExpiring = isExpiringInTwoDays(lastContract.contract_expiry_date);
            if (contractExpiring) {
              setShowRenewalButton(true);
            } else {
              setShowRenewalButton(false);
            }
          } else {
            setShowRenewalButton(false);
          }
        }
      }
    }
  }, [CustomerContracts])

  useEffect(() => {
    if (token) {
      dispatch(getCustomerContracts());

      dispatch(getCustomerUpdateProfileData(token));

    }
  }, [token]);


  const refresh = () => {
    if (token) {
      dispatch(getCustomerContracts());
      dispatch(getCustomerUpdateProfileData(token));

    }
  }

  const isValidJson = (str) => {
    try {

      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };


  const [id, setid] = useState(null)
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);

  const handleAddShow = (id) => {
    setid(id)
    setAddShow(true);
  };



  const [grid, setGrid] = useState(true)
  const arr = new Array(5).fill(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }

  const handleChange = async (e, id) => {
    // console.log(e.target.files[0]);
    setDisable(true)
    try {
      const token = Cookies.get('customertoken');

      // Create FormData instance and append the file
      let formData = new FormData();
      formData.append('image', e.target.files[0]);
      formData.append('document_id', id);

      let config = {
        headers: {
          "auth-token": token,
          'Content-Type': 'multipart/form-data', // Ensure multipart/form-data
        },
      };

      axios.post(`${adminMainUrl}/api/customer-profile/upload-disapproved-documents-again`, formData, config)
        .then(res => {
          if (res.status === 200) {

            toast.success(res.data.msg);
            setDisable(false);
            dispatch(getCustomerContracts());
          } else {
            toast.error(res.data.msg);
            setDisable(false);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response) {
            toast.error(err.response.data.msg);
          } else {
            toast.error("Internal server error.");
          }
          setDisable(false);
        });

    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.msg || "An error occurred.");
      setDisable(false);
    }
  };

  const currentItems = CustomerContracts
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Unique ID", dataIndex: "unique_id", key: "unique_id" },
    { title: "Document Type", dataIndex: "document_type", key: "document_type" },
    { title: "Approval Status", dataIndex: "approval_status", key: "approval_status" },
    { title: "Contract Start Date", dataIndex: "start_date", key: "start_date" },
    { title: "Contract End Date", dataIndex: "end_date", key: "end_date" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];


  const [dataSource, setDataSource] = useState([]);


  const giveApprovalStatus = (id) => {
    if (id) {
      if (id == 0) { return "PENDING" }
      else if (id == 1) { return "APPROVED" }
      else if (id == 2) { return "REJECTED" }
      else { return "PENDING" }
    } else {
      return "PENDING"
    }
  };



  const handleShowEditableContract = (id) => {
    if (id) {
      setShowEditContract(true)
      setContract_id(id);
    }
  };


  useEffect(() => {
    if (CustomerContracts) {
      let arr = [];
      CustomerContracts.map((val, index) => {
        arr.push({
          SNo: index + 1,
          unique_id: val?.contract_unique_id,
          document_type: val?.document_type,
          approval_status: val?.approval_status == 2 ? (<>
            <div style={{ color: "red" }}>
              {giveApprovalStatus(val?.approval_status)} {" "}
              <OverlayTrigger
                key={"top"}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-top`}>
                    {val?.rejection_reason ? val?.rejection_reason : "No reason provided."}
                  </Tooltip>
                }
              >
                <i className="fa-solid fa-circle-info"></i>
              </OverlayTrigger>
            </div>
          </>) : giveApprovalStatus(val?.approval_status),
          start_date: val?.contract_date ? DDMMMYYYYformateDate(val?.contract_date) : "-",
          end_date: val?.contract_expiry_date ? DDMMMYYYYformateDate(val?.contract_expiry_date) : "-",
          action: (
            (val?.document_type === "Auto Generated" && val?.approval_status === 0) ? (
              <button className="dropdown-item edit-popup" onClick={() => handleShowEditableContract(val?.id)}>
                <i className="fa-solid fa-pen text-blue me-1"></i> Sign Contract
              </button>
            ) : (val?.approval_status === 2) ? (
              <button className="dropdown-item edit-popup" onClick={() => handleShowEditableContract(val?.id)}>
                <i className="fa-solid fa-pen text-blue me-1"></i> Edit Contract
              </button>
            ) : null
          )
        });
      });

      setDataSource(arr);
    }

    if (loadingCustomerContracts) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [CustomerContracts, loadingCustomerContracts])

  // Generate the dataSource and check if any entry has 'DISAPPROVED'
  let showDisapprovalReason = false;

  const [disableRenewBtn, setDisableRenewBtn] = useState(false);
  const renewContract = () => {
    if (token) {
      setDisableRenewBtn(true);
      const config = { headers: { 'auth-token': token } }
      axios.get(`${adminMainUrl}/api/customer/contract-request-renewal`, config)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            setDisableRenewBtn(false);
            toast.success(res.data.msg);
            refresh();
          } else {
            setDisableRenewBtn(false);
            toast.error(res.data.msg);
          }
        }).catch(err => {
          console.log(err.message);
          setDisableRenewBtn(false);
          toast.error(err.message);
        })
    } else {
      toast.error("Token expired!")
    }
  }


  // Add the Disapproval Reason column conditionally
  if (showDisapprovalReason) {
    columns.push({ title: "Disapproval Reason", dataIndex: "disapprovalReason", key: "disapprovalReason" });
    columns.push({ title: "Upload Again", dataIndex: "UploadAgain", key: "UploadAgain" });
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">

          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Contract List<span className="count-title">{CustomerContracts?.length}</span>
                    </h4>
                  </div>
                  {showRenewalButton && <div className="col-4 text-end">
                    <div className="head-icons">
                      <button className="btn btn-sm btn-danger" onClick={renewContract} disabled={disableRenewBtn} > {disableRenewBtn && <i className="fas fa-spinner fa-spin"></i>} <i className="fa-solid fa-rotate-right"></i> Renew Contract</button>
                    </div>
                  </div>}
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="card">

            <div className="card-body">

              {/* Contact List */}
              {
                loadingCustomerContracts
                  ?
                  arr.map((value, index) => {
                    return (

                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    )
                  }) :
                  spinnerLoader ?
                    <>
                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    </> :
                    <>
                      <div className="table-responsive custom-table">
                        <Table className="table datanew dataTable no-footer" pagination={false}
                          dataSource={dataSource} columns={columns} />
                      </div>

                      <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                    </>
              }
              {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>


      <EditContract
        show={showEditContract}
        handleClose={handleCloseEditContract}
        ContractInfo={ContractInfo}
        contract_id={contract_id}
        loadingContractInfo={loadingContractInfo}
        CustomerProfileData={CustomerUpdateProfileData}
        refresh={refresh}
      />


    </>

  )
}

export default CustomerContractManagementList